import { activityHistoryFiltersSlice } from "../../slice";

export const { setCustomFilterGroupValue } = activityHistoryFiltersSlice.actions;
